import React from "react";
import { useDrop } from "react-dnd";
import { getImageUrl } from "../Helpers/Helpers";

const ItemTypes = {
  PRODUCT: "product",
};

const PlaceholderSlot = ({ index, product, onDrop, onRemove, currency }) => {
  const [{ isOver }, drop] = useDrop(
    () => ({
      accept: ItemTypes.PRODUCT,
      drop: (item) => onDrop(item.product, index),
      collect: (monitor) => ({
        isOver: !!monitor.isOver(),
      }),
    }),
    [index, onDrop],
  );

  const titre = product
    ? typeof product.titre === "object"
      ? product.titre.fr
      : product.titre
    : "";

  return (
    <div
      ref={drop}
      className="box"
      style={{
        border: isOver ? "3px dashed #007bff" : "2px dashed #dee2e6",
        backgroundColor: isOver ? "#f0f8ff" : "#f8f9fa",
        height: "150px",
        width: "150px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        transition: "all 0.3s ease",
        position: "relative",
      }}
    >
      {product ? (
        <>
          <button
            onClick={(e) => {
              e.stopPropagation();
              onRemove(index);
            }}
            className="btn btn-sm btn-danger"
            style={{
              position: "absolute",
              top: "5px",
              right: "5px",
              zIndex: 10,
              width: "25px",
              height: "25px",
              padding: "0",
              borderRadius: "50%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            ×
          </button>

          <div className="text-center">
            {product.image && product.image.length ? (
              <img
                src={getImageUrl(product.image)}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "images/product/no-image.png";
                }}
                alt={titre}
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "cover",
                  borderRadius: "8px",
                  marginBottom: "10px",
                }}
              />
            ) : (
              <div
                style={{
                  width: "80px",
                  height: "80px",
                  backgroundColor: "#e9ecef",
                  borderRadius: "8px",
                  marginBottom: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="fa fa-image fa-2x text-muted"></i>
              </div>
            )}
            <h6 className="text-truncate" style={{ maxWidth: "150px" }}>
              {titre}
            </h6>
            {product.prix && (
              <p className="text-success mb-0">
                <strong>
                  {product.prix} {currency}
                </strong>
              </p>
            )}
          </div>
        </>
      ) : (
        <div className="text-center text-muted">
          <i className="fa fa-plus-circle fa-3x mb-3"></i>
          <h6>Slot {index + 1}</h6>
          <p className="small mb-0">Déposer un produit ici</p>
        </div>
      )}
    </div>
  );
};

export default PlaceholderSlot;
